import cn from 'classnames'
import React from 'react'

import ButtonSharing from '@/components/ButtonSharing'
import { FavouriteButton } from '@/components/FavouriteButton'
import { ContextValue } from '@/context/Cities'
import { useUserNavigation } from '@/context/UserNavigationProvider'
import ArrowLeft from '@/design-lib/components/Icons/ArrowLeft'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'
import { handleListingDetailClick } from '@/utils/tracking/eventsHandlers'

import { roundedButton, wrapper } from './styles.css'

type Props = {
  cities: ContextValue
  listing: ListingCate
  topOffset?: boolean
}

const MobileFloatingButtons: React.FC<Props> = ({ cities, listing, topOffset = false }) => {
  const { currentPage, returnToLastCityPage, setLastCityFromListing } = useUserNavigation()

  if (cities && !currentPage && !!cities.router.city?.slug) {
    setLastCityFromListing(cities.router.city.slug)
  }

  return (
    <div className={wrapper} style={{ top: topOffset ? 53 + 46 : 46 }}>
      <button
        aria-label="Go back to list"
        className={roundedButton}
        data-testid="detail-back-button"
        onClick={() => {
          handleListingDetailClick('GoBack')
          returnToLastCityPage()
        }}
      >
        <ArrowLeft />
      </button>
      <div
        className={sprinkles({
          display: 'flex',
          gap: 's',
        })}
      >
        <ButtonSharing
          categoryForTracking="ListingDetail"
          cities={cities}
          className={sprinkles({
            marginRight: 'm',
          })}
          property={listing}
        />
        <FavouriteButton
          className={cn(
            roundedButton,
            sprinkles({
              padding: 's',
            })
          )}
          gtmTouchpoint="ListingDetail"
          id={listing.id}
        />
      </div>
    </div>
  )
}

export default MobileFloatingButtons
